// extracted by mini-css-extract-plugin
export default {"error":"Error_error__qlA5R","altError":"Error_altError__Qoju1"};